import React, { Component } from "react";
import "./Music.css";

// Import your audio file
import song from "./showreel-99195.mp3";

class Music extends Component {
  // Create state
  state = {
    // Get audio file in a variable
    audio: new Audio(song),

    // Set initial state of song
    isPlaying: false,
  };

  // Main function to handle both play and pause operations
  playPause = () => {
    // Get state of song
    let isPlaying = this.state.isPlaying;

    if (isPlaying) {
      // Pause the song if it is playing
      this.state.audio.pause();
    } else {
      // Play the song if it is paused
      this.state.audio.play();
    }

    // Change the state of song
    this.setState({ isPlaying: !isPlaying });
  };

  render() {
    return (
      <div>
        {/* Show state of song on website */}
        {/* <p>{this.state.isPlaying ? "Song is Playing" : "Song is Paused"}</p> */}

        {/* Button to call our main function */}
        <button
          id="m-btn"
          style={{
            border: `${
              this.state.isPlaying ? "5px solid gray" : "0px solid #c6c8cb"
            }`,
          }}
          onClick={this.playPause}
        >
          🎷
        </button>
      </div>
    );
  }
}

export default Music;
